function initialState() {
    return {
        tabsFields: []
    }
}

export default {
    state: initialState(),
    getters: {
        TABS_FIELDS: state => state.tabsFields,
    },
    mutations: {
        SET_TABS_FIELDS(state, payload) {
            let idx =state.tabsFields.findIndex(x=> x.tab === payload.tab)
            if(idx === -1) {
                state.tabsFields.push({tab : payload.tab, fields : [payload.field]})
            }
            else {
                state.tabsFields[idx].fields.push(payload.field);
            }

        },
        RESET_TABS(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })

        }
    },
    actions: {
        ADD_FIELD_TO_TAB: ({commit}, payload) => {
            commit('SET_TABS_FIELDS', payload);

        },
        RESET_ALL_TABS: ({commit}) => {
            commit('RESET_TABS');

        },
    }
}
